<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
      <div class="goback_search">
        <el-input
          v-model="searchValue"
          placeholder="请输入..."
          @input="search"
        ></el-input>
        <i class="el-icon-search"></i>
      </div>
    </div>
    <div class="search">
      <div class="pick">
        <div class="newDate" @click="showPickDate = true">
          {{ newDate }}
        </div>
        <i class="el-icon-date"></i>
        <van-popup v-model="showPickDate" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            :columns-order="['month', 'year', 'day']"
            @confirm="comfirmPickTime"
            @cancel="showPickDate = false"
          />
        </van-popup>
      </div>
      <div class="pick">
        <div class="newDate" @click="showPickText = true">
          {{ newText }}
        </div>
        <i class="el-icon-arrow-down"></i>
        <van-popup v-model="showPickText" position="bottom">
          <van-picker
            show-toolbar
            :default-index="defaultIndex"
            :columns="optionsQuarter"
            @confirm="onConfirmText"
            @cancel="showPickText = false"
          />
        </van-popup>
      </div>
    </div>
    <div class="radio_con">
      <div
        :class="item.id == radioValue ? 'active_item' : 'radio_item'"
        v-for="item in columns"
        :key="item.id"
        @click="handleRadioValue(item)"
      >
        <div class="item_name">{{ item.medalName }}</div>
      </div>
      <!-- <el-radio-group v-model="radioValue" @input="queryProjectList">
        <div
          v-for="item in columns"
          :key="item.id"
          :style="{ display: false ? 'none' : '' }"
        >
          <el-radio :label="item.id" v-if="true">{{ item.medalName }}</el-radio>
        </div>
      </el-radio-group> -->
    </div>
    <div class="content">
      <van-list
        v-if="historyList.length > 0"
        v-model="loadingOne"
        :finished="finishedOne"
        finished-text="没有更多了"
        @load="onLoadOne"
        loading-text="加载中，下拉查看更多"
        offset="10"
        :immediate-check="false"
      >
        <div
          class="list"
          @click="toUrl(item)"
          v-for="(item, index) in historyList"
          :key="index"
        >
          <!--       v-if="!item.fileId && item.medalName?.includes('流光')" -->
          <div class="top">
            <img
              class="img1"
              v-if="!item.fileId"
              src="@/assets/newMedal/history/1.png"
              alt=""
            />
            <!-- <img
              v-if="!item.fileId && item.medalName?.includes('星光')"
              class="img1"
              src="@/assets/newMedal/history/1.png"
              alt=""
            />
            <img
              v-if="!item.fileId && item.medalName?.includes('荣光')"
              class="img1"
              src="@/assets/newMedal/history/1.png"
              alt=""
            />
            <img
              v-if="!item.fileId && item.medalName?.includes('雷士')"
              class="img1"
              src="@/assets/newMedal/history/1.png"
              alt=""
            />

            <img
              v-if="
                !item.fileId &&
                !(
                  item.medalName?.includes('流光') ||
                  item.medalName?.includes('星光') ||
                  item.medalName?.includes('荣光') ||
                  item.medalName?.includes('雷士')
                )
              "
              class="img1"
              src="@/assets/newMedal/history/1.png"
              alt=""
            /> -->
            <img
              v-if="item.fileId"
              class="img1"
              :src="imgUrl + item.fileId"
              alt=""
            />
            <div class="position_text" v-if="!item.fileId">
              <div class="t1">
                {{ item.medalName }}
                <!-- {{
                item.medalType == 1
                  ? "流光勋章"
                  : item.medalType == 2
                  ? "星光勋章"
                  : item.medalType == 3
                  ? "荣光勋章"
                  : item.medalType == 4
                  ? "雷士照明勋章"
                  : ""
              }} -->
              </div>
              <div class="t2">
                {{
                  item.medalName?.includes("流光")
                    ? "LiuGuangXunZhang"
                    : item.medalName?.includes("星光")
                    ? "XingGuangXunZhang"
                    : item.medalName?.includes("荣光")
                    ? "RongGuangXunZhang"
                    : item.medalName?.includes("雷士照明")
                    ? "LeiShiZhaoMing"
                    : ""
                }}
              </div>
            </div>
            <img class="img2" :src="imgUrl + item.iconId" alt="" />
          </div>
          <div class="text">{{ item.title }}</div>
          <div class="footer">
            <div class="left">
              <!-- {{ item.publisherName }}
              <span style="margin: 0 5px">
                <span v-if="item.departmentName">|</span> 
                </span> -->
              {{ item.departmentName }}
            </div>
            <div class="right">{{ item.create_time }}</div>
          </div>
        </div>
      </van-list>
      <div class="kong_con" v-else>
        <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
        <div class="kong_title kong_title1">您还没有参与相关提报项目</div>
        <div class="kong_title">请加油吧～</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/medal";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      searchValue: "",
      showPickDate: false,
      showPickText: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      newDate: moment(new Date()).format("YYYY"),
      newText: "请选择",
      newValue: "",
      columns: [],
      historyList: [],
      imgUrl: "",
      loadingOne: false,
      finishedOne: false,
      total: 0,
      page: 1,
      pageSize: 20,
      radioValue: "",
      optionsQuarter: [],
      showList: [],
      defaultIndex: 0
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    if (this.$route.query.year) {
      this.newDate = this.$route.query.year;

      this.newValue = this.$route.query.quarter;
    }
    this.queryQuarter();
    this.showBadge();
  },
  methods: {
    // 格式化时间
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return ``;
      } else if (type === "day") {
        return ``;
      }
      return val;
    },
    // 返回
    goback() {
      this.$router.go(-1);
    },
    // 搜索
    search() {
      // this.queryProjectList();
      this.showBadge();
    },
    // 选择年份
    comfirmPickTime(value) {
      this.newDate = moment(value).format("YYYY");
      this.currentDate = value;
      // this.queryProjectList();
      this.showBadge();
      this.showPickDate = false;
    },
    // 选择季度
    onConfirmText(value) {
      this.newText = value.text;
      this.newValue = value.value;
      this.showPickText = false;
      // this.queryProjectList();
      this.showBadge();
    },
    //跳转往期详情
    toUrl(item) {
      localStorage.setItem("historyDetail", JSON.stringify(item));
      this.$router.push({ path: "/mobile/medal/newsNotice/historyDetail" });
    },
    // 查询分类
    queryClassification(list) {
      api.queryClassificationApi({ cardType: 2 }).then(data => {
        this.columns = data.data.filter(item => list.includes(item.id));
        // if (this.$route.query.year) {
        //   this.radioValue = Number(this.$route.query.medalId);
        // } else {
        this.radioValue = this.columns[0]?.id;
        // }

        this.onLoadOne();
        // this.columns = data.data;
      });
    },
    // 查询勋章
    showBadge() {
      api
        .queryButton({
          year: this.newDate,
          keyWord: this.searchValue,
          // medalId: this.radioValue,
          quarter: this.newValue,
          page: this.page,
          pageSize: this.pageSize,
          excellent: 1
        })
        .then(data => {
          // this.columns = data.data;
          this.queryClassification(data.data);
        });
    },
    onLoadOne() {
      this.queryProjectList();
    },
    //往期列表
    queryProjectList() {
      api
        .queryProjectListApi({
          year: this.newDate,
          keyWord: this.searchValue,
          medalId: this.radioValue,
          quarter: this.newValue,
          page: this.page,
          pageSize: this.pageSize,
          excellent: 1
        })
        .then(res => {
          if (res.code == 200) {
            this.total = res.data.total;
            this.finishedOne = false;
            if (this.page === 1) {
              this.historyList = res.data.list;
            } else {
              this.historyList = this.historyList.concat(res.data.list);
            }
            if (this.historyList.length < this.total) {
              this.page = this.page + 1;
            } else {
              this.finishedOne = true;
            }

            this.loadingOne = false;
            this.historyList.map(item => {
              item.create_time = moment(item.create_time).format("YYYY-MM-DD");
            });
          }
        });
    },

    //季度
    queryQuarter() {
      api.queryByType({ type: "quarter" }).then(res => {
        if (res.code == 200) {
          this.optionsQuarter = res.data.map(item => {
            return {
              value: item.key,
              text: item.value
            };
          });
          if (this.$route.query.year) {
            const info = this.optionsQuarter.filter(
              item => item.value == this.$route.query.quarter
            );
            this.defaultIndex = this.optionsQuarter.findIndex(
              item => item.value == this.$route.query.quarter
            );
            this.newText = info[0].text;
          }
        }
      });
    },
    //点击tabs,获取往期列表
    handleRadioValue(item) {
      this.radioValue = item.id;
      this.page = 1;
      this.queryProjectList();
    }
  }
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .detail_title_info {
    width: 100%;
    height: 100%;
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  .pick {
    width: 48%;
    height: 80px;
    border-radius: 80px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    margin-bottom: 15px;
    .newDate {
      flex: 1;
      // height: 40px;
    }
    div {
      color: #969b9e;
      font-size: 30px;
    }
    i {
      color: #969b9e;
    }
  }
}
.radio_con {
  margin: 10px 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  .radio_item {
    padding: 14px 24px;
    border-radius: 20px;
    color: #969b9e;
    font-size: 26px;
  }
  .active_item {
    padding: 14px 24px;
    background: #1fbe8a;
    font-size: 26px;
    color: #ffffff;
    border-radius: 20px;
  }
  // ::v-deep {
  //   // .van-radio__label {
  //   //   font-size: 24px;
  //   // }
  //   .el-radio-group {
  //     // margin-right: 20px;
  //     display: flex;
  //     align-items: center;
  //     justify-content: space-around;
  //     .el-radio {
  //       margin-right: 0;
  //     }
  //   }
  //   .el-radio__inner {
  //     width: 34px;
  //     height: 34px;
  //     background: #fff;
  //   }
  //   .el-radio__inner::after {
  //     background: #409eff;
  //     width: 22px;
  //     height: 22px;
  //   }
  // }
}
.content {
  overflow: auto;
  height: calc(100vh - 385px);
  margin-top: 30px;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .list {
    margin-bottom: 40px;
    font-size: 30px;
    background: #fff;
    padding: 50px 30px 30px;
    border-radius: 40px;
    .top {
      display: flex;
      justify-content: center;
      position: relative;
      min-height: 180px;
      .img1 {
        width: 98%;
      }
      .position_text {
        position: absolute;
        color: #a76a33;
        top: 24%;
        left: 10%;
        .t1 {
          font-size: 48px;
          font-weight: bold;
          letter-spacing: 10px;
        }
        .t2 {
          font-size: 26px;
          letter-spacing: 1px;
        }
      }
      .img2 {
        position: absolute;
        top: -60px;
        right: -3%;
        // width: 350px;
        width: 50%;
        // height: 24vh;
      }
    }
    .text {
      margin-top: 40px;
      padding-left: 10px;
      line-height: 48px;
      font-size: 30px;
    }
    .footer {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding-left: 10px;
      margin-top: 30px;
      color: #91929e;
      .left {
        display: flex;
        align-items: center;
      }
      .right {
        // 文字不换行
        white-space: nowrap;
        margin-top: 4px;
      }
    }
  }
  .kong_con {
    width: 100%;
    height: 60%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    justify-content: center;
    .kong_img {
      width: 450px;
      height: 450px;
    }
    .kong_title1 {
      margin-top: 30px !important;
    }
    .kong_title {
      color: #999999;
      font-size: 26px;
      margin-top: 10px;
    }
  }
}
</style>
